import React from "react";

/* -----------------------------------------------------------
   BotChainCP — Logo system
   - <LogoMark /> : icon only (gradient + diagonal growth line)
   - <LogoWordmark /> : wordmark text only
   - <Logo /> : full horizontal lockup (mark + wordmark)
   ----------------------------------------------------------- */

export function LogoMark({ size = 36, variant = "gradient", className = "" }) {
  // One mark everywhere: the 3D bot-head-in-a-chain-ring emblem. `variant` is kept
  // for the callers that still pass it — the cutout reads on light and dark alike.
  void variant;
  return (
    <img
      src="/brand/botchain-mark.png"
      srcSet="/brand/botchain-mark.png 1x, /brand/botchain-mark@2x.png 2x"
      width={size}
      height={size}
      alt="BotChainCP"
      className={className}
      style={{ width: size, height: size, objectFit: "contain", display: "block" }}
    />
  );
}

export function LogoWordmark({ size = 22, color = "currentColor", className = "" }) {
  // Render the wordmark "botchaincp" — letter-spacing tight, Montserrat SemiBold
  return (
    <span
      className={`font-display ${className}`}
      style={{
        fontFamily: "'Montserrat', system-ui, sans-serif",
        fontWeight: 600,
        fontSize: size,
        letterSpacing: "-0.035em",
        color,
        lineHeight: 1,
      }}
    >
      botchaincp
    </span>
  );
}

export default function Logo({ size = "md", variant = "gradient", showWordmark = true, className = "" }) {
  // size: "sm" | "md" | "lg"
  const map = {
    sm: { mark: 32, word: 18, gap: 8 },
    md: { mark: 36, word: 22, gap: 10 },
    lg: { mark: 48, word: 30, gap: 12 },
  };
  const s = map[size] || map.md;
  return (
    <div className={`inline-flex items-center ${className}`} style={{ gap: s.gap }}>
      <LogoMark size={s.mark} variant={variant} />
      {showWordmark && <LogoWordmark size={s.word} color={variant === "mono-light" ? "#FFFFFF" : "#0F1226"} />}
    </div>
  );
}
